/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verification_Already_ExistsInputs */

const en_us2_verification_already_exists = /** @type {(inputs: Verification_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not send your code. Please try again.`)
};

const pt_br2_verification_already_exists = /** @type {(inputs: Verification_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar seu código. Tente de novo.`)
};

const es_419_verification_already_exists = /** @type {(inputs: Verification_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos enviar tu código. Intenta de nuevo.`)
};

const pt_pt2_verification_already_exists = /** @type {(inputs: Verification_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar o teu código. Tenta outra vez.`)
};

const fr_fr2_verification_already_exists = /** @type {(inputs: Verification_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'envoyer ton code. Réessaie.`)
};

const de_de2_verification_already_exists = /** @type {(inputs: Verification_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Code konnte nicht gesendet werden. Versuch es bitte noch mal.`)
};

const it_it2_verification_already_exists = /** @type {(inputs: Verification_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile inviare il codice. Riprova.`)
};

/**
* | output |
* | --- |
* | "We could not send your code. Please try again." |
*
* @param {Verification_Already_ExistsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const verification_already_exists = /** @type {((inputs?: Verification_Already_ExistsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verification_Already_ExistsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_verification_already_exists(inputs)
	if (locale === "es-419") return es_419_verification_already_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_verification_already_exists(inputs)
	if (locale === "fr-FR") return fr_fr2_verification_already_exists(inputs)
	if (locale === "de-DE") return de_de2_verification_already_exists(inputs)
	if (locale === "it-IT") return it_it2_verification_already_exists(inputs)
	return en_us2_verification_already_exists(inputs)
});
export { verification_already_exists as "verification.already_exists" }